import { createFileRoute, Outlet } from '@tanstack/react-router';
import AuthLayout from 'src/features/plugins/outlook/(auth)/layout';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth')({
  component: () => (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  ),
});
